import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeCustomProp, makeStringProp } from '@/utils';

const { name, bem } = createNamespaceBem('pkg');

export type PkgThemeType = 'default' | 'blue' | 'orange' | 'green' | 'purple';

const pkgProps = {
  data: makeCustomProp<any>(Object, null),
  theme: makeStringProp<PkgThemeType>('default'),
  title: makeStringProp(''),
};

export type PkgProps = ExtractPropTypes<typeof pkgProps>;

export default defineComponent({
  name,
  props: pkgProps,
  emits: ['click'],
  setup(props, { emit }) {
    const clickPkg = () => {
      emit('click', props.data);
    };
    return () => (
      <div class={bem([props.theme])} onClick={clickPkg}>
        <div class={bem('title')}>{props.title}</div>
      </div>
    );
  },
});
